export interface IotStackDocument {
    generateIotStack: boolean,
    mqtt: MqttSelection
}

export enum MqttSelection {
    NONE = "none",
    MOSQUITTO = "mosquitto",
    SELF = "self"
}